import type { ReactSetState } from "client/types/ReactSetState";
import { useEffect, useState } from "react";
import { ColorInput } from "../ColorInput/ColorInput";
import tinycolor from "tinycolor2";
import { translateFunc } from "client/utils/translateFunc";

export interface TextColorInputProps {
    color: string;
    onChange: ReactSetState<string>;
}

export const TextColorInput = ({ color, onChange: _onChange }: TextColorInputProps) => {
    const [value, setValue] = useState(color);
    const onChange = (value: string) => {
        value = value.toUpperCase();
        setValue(value);
        const tiny = tinycolor(value);
        if (!tiny.isValid()) return;
        _onChange(value);
    };
    useEffect(() => {
        setValue(color);
    }, [color]);
    return <ColorInput label={translateFunc("text-color")} value={value} onChange={onChange} />;
};
